import Skeleton from 'react-loading-skeleton'
import './GameRoomsCardSkeleton.css'

export default function GameRoomsCardSkeleton() {
  return (
    <div className='GR-Card-Skeleton'>
      {/* Row 1 */}
      <div className='flex-row' style={{ marginBottom: '20px' }}>
        {/* Game Room name section */}
        <div className='gm-name-section u-capitalize'>
          <Skeleton width={100} height={20} />
          <Skeleton width={180} height={30} />
        </div>

        {/* GR logo section */}
        <div className='flex-row' style={{ gap: '10px' }}>
          <div className='TeamLogoContainer'>
            <Skeleton circle width={50} height={50} />
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className='flex-row'>
        {/* Prize section */}
        <div className='gr-prize-section'>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Skeleton width={80} height={50} />
          </div>
        </div>

        {/* Join button + Entry Fee */}
        <div className='join-btn-area'>
          <Skeleton width={80} height={50} />
        </div>
      </div>
    </div>
  )
}
